import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import Modal from "./modules/frontv2/Modal";
import GlobalFilters from "./modules/frontv2/GlobalFilters";
import MobileLightbox from "./modules/frontv2/MobileLightbox";
import MobileSearch from "./modules/frontv2/MobileSearch";
import Lightbox from "./modules/frontv2/Lightbox";
import Wish from "./modules/frontv2/Wish";
import tippy from "tippy.js";
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
// import { init as sentryInit } from "@sentry/browser";
import { getUserLanguage } from "./modules/utils";
import { initGlide } from "./modules/common/glide";
import { initDrops } from "./modules/common/drop";
import { initScroll } from "./modules/scrolling";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initSeeMore } from "./modules/common/see-more";
import { initScrollInto } from "./modules/common/scroll-into";
import { initCookies } from "./modules/common/cookies";
import { initFormValidation } from "./modules/common/form-validation";
import { initOutsideView } from "./modules/common/outside-view";
import { initMessages } from "./modules/common/message";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { initCommon } from "./modules/common/common";
import { initSortReviews } from "./modules/frontv2/Reviews";
import { initMapbox } from "./modules/frontv2/Mapbox";
import { initCollapsible } from "./modules/collapsible";
import ReviewsPagination from "./modules/frontv2/ReviewsPagination";
import MobileMenu from "./modules/frontv2/MobileMenu";
import { initSwiper } from "./modules/common/init-swiper";
import { initSeeMoreContent } from "./modules/frontv2/seeMoreContent";
import { initBusinessDeletionRequest, initRecommendWinalistButton } from "./modules/frontv2/virtual-host-utils";

document.addEventListener('DOMContentLoaded', () => {
  // Init Sentry JS
  // if(document.body.dataset.env === 'prod') {
  //   sentryInit({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  // }

  flatpickr.localize(flatpickrLanguages[getUserLanguage()]);

  //common stuff
  initCommon();

  //Init glide (carousel)
  initGlide();

  //Dropdowns and dropups
  initDrops();

  //Modal popups
  Modal.bindAllModals();

  //Header bar scroll logic
  initScroll();

  //Search bar logic (algolia)
  initAutocomplete();

  //Mobile menu
  initMobileMenu();

  //Init see more logic (description of the exp)
  initSeeMore();

  initScrollInto();

  //Init global filters
  new GlobalFilters();

  //Init lightboxes (both desktop and mobile)
  new Lightbox("#lightbox");
  new MobileLightbox();

  //Init mobile search
  new MobileMenu();
  new MobileSearch();

  //Init wish add/remove buttons
  Wish.bindWishButtons();

  //Init cookies
  initCookies();

  initFormValidation();

  initOutsideView();

  //Analytics
  initGoogleEcommerce();

  tippy('[data-tippy-content]', {
    theme: 'light'
  });

  initSortReviews();

  initMapbox();

  initCollapsible();

  //Handle AJAX Reviews Pagination
  new ReviewsPagination();

  initSeeMoreContent();

  //for virtual host page
  initRecommendWinalistButton();
  initBusinessDeletionRequest();

  //Custom flash messages
  initMessages();

  // Swiper logic for slider
  initSwiper();
});
